import styled from "styled-components"
import { CenterMiddle } from "../../global-styles/mixins"

export const Container = styled.div`
    ${CenterMiddle}
`